export const CROSS_HAIR_LINE_COLOR_ORDER = ['rgb(255,255,255, 0.5)', 'rgb(0,0,0, 0.5)', 'none'];